import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import tokens from '../theme/tokens';

// 말풍선 하나 — 내 메시지(customer)는 오른쪽 주황, 상담원은 왼쪽 흰색, 시스템 줄은 가운데 작은 글씨
const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: 10,
    '&$mine': { justifyContent: 'flex-end' },
  },
  mine: {},
  stack: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '78%',
    '$mine &': { alignItems: 'flex-end' },
  },
  name: {
    marginBottom: 4,
    marginLeft: 2,
    fontSize: 12,
    fontWeight: 700,
    color: tokens.muted,
    letterSpacing: -0.4,
  },
  bubble: {
    padding: '10px 14px',
    borderRadius: '16px 16px 16px 4px',
    border: `1px solid ${tokens.line}`,
    backgroundColor: tokens.surface,
    color: tokens.ink,
    fontSize: 14,
    lineHeight: 1.55,
    letterSpacing: -0.4,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    '$mine &': {
      borderRadius: '16px 16px 4px 16px',
      border: 'none',
      backgroundColor: tokens.primary,
      color: tokens.surface,
    },
  },
  time: {
    flex: 'none',
    margin: '0 6px 2px',
    fontSize: 11,
    color: tokens.muted,
  },
  system: {
    margin: '6px auto 12px',
    padding: '4px 12px',
    borderRadius: 12,
    backgroundColor: tokens.surfaceSoft,
    color: tokens.muted,
    fontSize: 12,
    letterSpacing: -0.4,
    textAlign: 'center',
    wordBreak: 'keep-all',
  },
  link: { color: 'inherit', textDecoration: 'underline' },
}));

const fmtTime = (at) => {
  const d = new Date(at);
  if (isNaN(d.getTime())) return '';
  const h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, '0');
  return `${h < 12 ? '오전' : '오후'} ${h % 12 || 12}:${m}`;
};

function ChatBubble({ message, showName = true }) {
  const cs = useStyles();
  if (message.senderKind === 'system' || message.type === 'system') {
    return <div className={cs.system}>{message.text}</div>;
  }
  const mine = message.senderKind === 'customer';
  const body = message.type === 'photo' && message.url
    ? <a className={cs.link} href={message.url} target="_blank" rel="noopener noreferrer">사진 보기</a>
    : message.text;
  return (
    <div className={clsx(cs.row, mine && cs.mine)}>
      {mine && <span className={cs.time}>{fmtTime(message.at)}</span>}
      <div className={cs.stack}>
        {!mine && showName && <span className={cs.name}>{message.senderName || '퀴노스'}</span>}
        <div className={cs.bubble}>{body}</div>
      </div>
      {!mine && <span className={cs.time}>{fmtTime(message.at)}</span>}
    </div>
  );
}

export default ChatBubble;
